import { render, staticRenderFns } from "./VeneerConsentForm.vue?vue&type=template&id=5a1f6971&scoped=true"
import script from "./VeneerConsentForm.vue?vue&type=script&lang=js"
export * from "./VeneerConsentForm.vue?vue&type=script&lang=js"
import style0 from "./VeneerConsentForm.vue?vue&type=style&index=0&id=5a1f6971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f6971",
  null
  
)

export default component.exports